import '../App.css';
import React from "react";

export class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <p>Made with 💚 by team Screen Green Machine</p>
                <p>Copyright® 2021 Screen Green Machine</p>
            </div>
        )
    }
}